import React from 'react';
import PropTypes from 'prop-types';
import {connectToStores} from 'epic-alt-utils/index';
import SectionSwiper from '../../components/sectionSwiper/SectionSwiper';
import SplashBlock from '../../components/home/SplashBlock/SplashBlock';
import NewBeginningBlock from '../../components/home/NewBeginningBlock/NewBeginningBlock';
import CharacterBlock from '../../components/home/CharacterBlock/CharacterBlock';
import NewItemsBlock from '../../components/home/NewItemsBlock/NewItemsBlock';
import NewMapsBlock from '../../components/home/NewMapsBlock/NewMapsBlock';
import SocialContent from '../../components/home/SocialContent/SocialContent';
import EpicGamesFooterWrapper from '../../components/footer/Footer';
import MetaTags from '../../components/common/MetaTags';
import {HomeStore, LoginStore, LocalizationStore, HeaderStore, FooterStore} from '../../stores';

@connectToStores
export default class HomeView extends React.Component {
    static getStores() {
        return [HomeStore, LoginStore, LocalizationStore, HeaderStore, FooterStore];
    }

    static getPropsFromStores() {
        return {
            homePageData: HomeStore.getState(),
            loginStore: LoginStore.getState(),
            localizationStore: LocalizationStore.getState(),
            headerStore: HeaderStore.getState(),
            footerStore: FooterStore.getState()
        };
    }
    static propTypes = {
        homePageData: PropTypes.object,
        loginStore: PropTypes.object,
        localizationStore: PropTypes.object,
        headerStore: PropTypes.object,
        footerStore: PropTypes.object,
        match: PropTypes.object
    };

    state = {
        isFinalSection: false
    }

    render() {
        const {
            homePageData,
            headerStore,
            loginStore,
            footerStore,
            localizationStore
        } = this.props;
        const {
            _title,
            splashBlock,
            newBeginningBlock,
            characterBlock,
            newItemsBlock,
            newMapsBlock
        } = homePageData.data;
        const { mobile, tablet } = headerStore;
        const isDesktop = !mobile() && !tablet();

        return (
            <div className="HomeView">
                <MetaTags meta={{title: _title}} />
                <SectionSwiper
                    setIsFinal={isFinalSection => this.setState({isFinalSection})}
                    sections={[
                        {
                            component: SplashBlock,
                            props: {block: splashBlock, isDesktop}
                        },
                        {
                            component: NewBeginningBlock,
                            props: {block: newBeginningBlock}
                        },
                        {
                            component: CharacterBlock,
                            props: {block: characterBlock}
                        },
                        {
                            component: NewItemsBlock,
                            props: {block: newItemsBlock}
                        },
                        {
                            component: NewMapsBlock,
                            props: {block: newMapsBlock}
                        },
                        {
                            component: EpicGamesFooterWrapper,
                            props: { loginStore, footerStore, localizationStore },
                            adpativeHeight: true,
                            hasUpOnClickProp: true
                        }
                    ]} />
                <SocialContent active={!this.state.isFinalSection} />
            </div>
        );
    }
}
